module.exports = __webpack_public_path__ + "static/media/idia-app.ad2188f6.png";